import { SEARCH } from '@/queries';
import { availableFirst, withSearchLoading } from '~/lib/search';

// Find and attach the active parking schedule to each search result
const attachActiveSchedules = (searchResults) => {
  if (!searchResults) return [];
  
  return searchResults.map(result => {
    const activeSchedule = result.applicableSchedule
      ? result.lot?.parkingSchedules?.find(schedule => schedule.id === result.applicableSchedule)
      : null;
    
    return {
      ...result,
      activeSchedule
    };
  });
};

export const useSearch = async (id, checkInDate, checkOutDate, byFacility = true) => {
  const facilitySearch = useFacilitySearch();
  const searchStore = useSearchStore();

  const reservationTypes = searchStore.isOvernight ? ['OVERNIGHT'] : ['DAILY', 'HOURLY'];

  const request = {
    checkinDate: checkInDate || '',
    checkoutDate: checkOutDate || '',
    reservationTypes: reservationTypes
  }

  if (byFacility) {
    request.facility = (id === 'all') ? null : id;
  } else {
    request.collection = id ? id : null;
  }

  try {
    const { data } = await withSearchLoading(facilitySearch, () => useGraphQL(SEARCH, useTokens().access, request));
    const resultsWithSchedules = attachActiveSchedules(data?.value?.data?.search);
    facilitySearch.setSearchResults(availableFirst(resultsWithSchedules));

    return {
      isLoading: false,
      error: null,
      results: resultsWithSchedules
    }
  } catch (error) {
    console.error('Error Getting Codes:', error);
  }
}
